import React, { useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import flowplayer from "@flowplayer/player";
import { trackBehaviorUsage } from "./usage";
// - Components
const Flowplayer = (props, receivedRef) => {
    const { token, src, opts } = props;
    const ref = useRef(null);
    const playerApi = () => ((ref === null || ref === void 0 ? void 0 : ref.current) ? flowplayer(ref.current) : null);
    useImperativeHandle(receivedRef, () => ref === null || ref === void 0 ? void 0 : ref.current);
    // Init Flowplayer on mount
    useEffect(() => {
        if (typeof ref === "function")
            return;
        if (!ref)
            return;
        if (!ref.current)
            return;
        if (!token)
            return;
        const api = flowplayer(ref === null || ref === void 0 ? void 0 : ref.current, Object.assign({ token }, opts));
        trackBehaviorUsage(api, "flowplayer-component-mounted");
        return () => {
            api.destroy();
            if (ref === null || ref === void 0 ? void 0 : ref.current)
                ref.current.innerHTML = "";
        };
    }, [token, ref]);
    useEffect(() => {
        if (!opts)
            return;
        const api = playerApi();
        api === null || api === void 0 ? void 0 : api.setOpts(opts);
    }, [opts]);
    useEffect(() => {
        if (!src)
            return;
        const api = playerApi();
        api === null || api === void 0 ? void 0 : api.setSrc(src);
    }, [src]);
    return React.createElement("div", { ref: ref });
};
// - Exports
Flowplayer.displayName = "Flowplayer";
export default forwardRef(Flowplayer);
